.kg{right:0.25rem;}